import Images from "../Assets/Images";

const projects = [
    {
        id: "scopr-dashboard",
        title: "SCOPR Dashboard",
        thumbnail: Images.Scopr.Thumbnail.src,
        description: "A React dashboard app for managing data and analytics at SCOPR.",
        descriptionFull: "For my graduate Thesis, I made this Dashboard for SCOPR where I did my internship. The frontend is in React together with Tailwind CSS. The backend is an ASP.NET Web API that connects to MongoDB. This dashboard provides a visual representation of the projects of users.",
        gallery: [
            Images.Scopr.StartPagina,
            Images.Scopr.ProjectenOverzicht,
            Images.Scopr.Project1,
            Images.Scopr.Project2,
            Images.Scopr.Project3,
            Images.Scopr.Users,
        ],
        tags: ["React", "JavaScript", "REST API", "C#", ".NET", "Tailwind CSS", "MongoDB" ],
        date: "June 2025"

    },
    {
        id: "budge",
        title: "Budge (Mobile App)",
        thumbnail: Images.Budge.BudgeThumbnail.src,
        description: "A mobile budgeting app to gain insight into your spending",
        descriptionFull: "This was my first time creating a full-on mobile application with users, a database and an API. This gave me confidence in that if I wanted to build an app, I could do it.",
        gallery: [
            Images.Budge.LoginPage,
            Images.Budge.RegisterPage,
            Images.Budge.OverviewPage,
            Images.Budge.AddTransaction,
            Images.Budge.SingleTransaction,
            Images.Budge.FilterPage
        ],
        tags: ["C#", ".NET MAUI", "XAML", "REST API", "JWT", "SQLServer"],
        date: "January 2025"

    },
    // {
    //     id: "weightlogger",
    //     title: "Weightlogger",
    //     thumbnail: Images.WeightLogger.homepage.src,
    //     description: "A webapp for tracking weight over time.",
    //     descriptionFull: "a very small project to get to learn a bit about React. This was fun to create since I was already tracking my weight but it was nice to have a visual representation and a place to save those stats.np",
    //     gallery: [
    //         Images.WeightLogger.homepage
    //     ],
    //     tags: ["React", "JS", "SQLServer"],
    //     date: "April 2023"
    //
    // },
    {
        id: "encryption-tool",
        title: "Encryption Tool",
        thumbnail: Images.Encryption.Encryption.src,
        description: "A utility tool for encrypting and decrypting sensitive data.",
        gallery: [
            Images.Encryption.KeysMaken,
            Images.Encryption.FotoEncrypteer,
            Images.Encryption.FotoDecrypteer,
            Images.Encryption.RSA
        ],
        tags: ["C#", ".NET", "Security", "XAML"],
        date: "May 2025"

    },
    // {
    //     id: "webshop-1",
    //     title: "Futurisma - webshop",
    //     thumbnail: Images.Futurisma.FuturismaLogo.src,
    //     description: "A full-stack webshop project with shopping cart and checkout functionality.",
    //     descriptionFull: "Futurisma, a fictional island, is a project that was started during 'Werkplekleren 1'. We assembled a team of 4 students who had to work together to create a full working webshop, both frontend and backend. We used SQLServer as database and created our own API. We also made a seperate WPF-application for admins to control the catalogue and users/orders.",
    //     gallery: [
    //         Images.Futurisma.FuturismaLanding,
    //         Images.Futurisma.FuturismaProducts,
    //         Images.Futurisma.FuturismaCabins,
    //         Images.Futurisma.FuturismaContact,
    //         Images.Futurisma.FuturismaSingleProduct,
    //         Images.Futurisma.FuturismaWPF,
    //         Images.Futurisma.FuturismaDatabase
    //     ],
    //     tags: ["Vue", "C#", ".NET", "REST API", "SQLServer", "JavaScript", "WPF"],
    //     date: "May 2024"
    //
    // },
    // {
    //     id: "portfolio-website",
    //     title: "Portfolio Website",
    //     thumbnail: Images.Portfolio.PortfolioThumbnail.src,
    //     description: "A simple HTML portfolio website showcasing projects and skills.",
    //     descriptionFull: "My first encounter with HTML and CSS, learning the basics with this projects. Since it contains a lot of personal information and reflection, the screenshots of this project are limited.",
    //     gallery: [
    //         Images.Portfolio.LandingPage,
    //         Images.Portfolio.Vaardigheden,
    //         Images.Portfolio.LeukeWeetjes
    //     ],
    //     tags: ["HTML", "CSS", "JavaScript"],
    //     date: "december 2023"
    // },
    {
        id: "bitcoinminer",
        title: "Bitcoin Miner",
        thumbnail: Images.BtcMiner.BtcMinerThumbnail.src,
        description: "A clicker game based on 'Cookie Clicker', do you have what it takes to accumulate 1 million BTC?",
        descriptionFull: "This was my first project, a game based on 'Cookie Clicker'. It was fun to build and a great learning experience since this wasn't a throwaway project that you build in hours during class. All the things learned in class came together in this project and I'm happy with the result.",
        gallery: [
            Images.BtcMiner.StartScreen,
            Images.BtcMiner.FirstItem,
            Images.BtcMiner.BonusShop,
            Images.BtcMiner.EndGame,
            Images.BtcMiner.GoldenCoin,
            Images.BtcMiner.Quests,
            Images.BtcMiner.Stats
        ],
        tags: ["C#", ".NET", "WPF", "XAML", "GIT"],
        date: "December 2023"
    },
];

export default projects;
